import React from "react";

export const Header = ({ signUpModel }) => {
  const { registrationTitle, registrationText, flow } = signUpModel;

  return (
    <header className={"sign-up__header"}>
      <h2 className={"sign-up__title"}>{registrationTitle}</h2>
      <h6 className={"sign-up__subtitle"} dangerouslySetInnerHTML={{ __html: registrationText }}></h6>
    </header>
  );
}
